


















































































import Vue from "vue";
import { dataTableItemsPerPage } from "@/utility/Constants";

// Vue components
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";

//Model
import { Installation } from "@/model/data/Installation";
import { findParentNodesFromInstallationName } from "@/utility/TreeviewUtility";
import { mapState } from "vuex";

export default Vue.extend({
    components: {
        ColumnVisibilityFilter,
    },
    props: {
        installations: Array as () => Array<Installation>,
        paginatedTotalItems: Number,
        loading: Boolean,
        deleteLoading: Boolean,
    },
    data() {
        return {
            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            dataTableItemsPerPage,
            availableHeaders: [],
            options: {},
            ignoreOptionsChanges: false,
            search: "",
            installationToDelete: [],
            initialAvailableHeaders: [
                {
                    enabled: true,
                    text: this.$t("common.name"),
                    value: "name",
                },
                {
                    enabled: false,
                    text: this.$t("platformMaintenance.foldersPath"),
                    value: "parentFolder",
                },
                {
                    enabled: true,
                    text: this.$t("common.agent_ip"),
                    value: "agentInfo.ip",
                },
                {
                    enabled: false,
                    text: this.$t("device_status.agent_remote_ip"),
                    value: "agentInfo.remoteIp",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("device_status.agent_remote_port"),
                    value: "agentInfo.remotePort",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("common.last_agent_message"),
                    value: "agentInfo.lastMessage",
                    sortable: true,
                },
                {
                    enabled: true,
                    text: this.$t("device_status.agent_version"),
                    value: "agentInfo.version",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("common.osVersion"),
                    value: "agentInfo.osVersion",
                    sortable: false,
                },
            ],
        };
    },
    computed: {
        ...mapState({
            deviceTree: (state: any) => state.devices.deviceTree,
        }),
    },
    watch: {
        options: {
            handler(newOptions, oldOptions) {
                if (oldOptions != null) {
                    if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                    if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
                }
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
        loading(newVal) {
            if (!newVal) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
    },
    methods: {
        findParentNodesFromInstallationName,
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
            }
        },
        onDelete() {
            this.$emit(
                "delete",
                this.installationToDelete.map((inst) => inst.installationName)
            );
        },
        getFoldersPath(installationName) {
            if (installationName) {
                let result = this.findParentNodesFromInstallationName(this.deviceTree, installationName);
                return result
                    .map((o) => o.name)
                    .join("/")
                    .replace("//", "/");
            }
            return "";
        },
    },
});
